import { Map, Set } from 'immutable';
import { pathSubscription, regSub, subscribe } from 'nike-re-framejs';
import { cashinOfferStatus } from '@/mytickets/constants/cashinOfferStatus';

const HIDDEN_CASHIN_STATUSES = [cashinOfferStatus.Finished, cashinOfferStatus.NotAvailable];

function isActiveCashin(cashinOffer) {
    if (!cashinOffer) {
        return false;
    }
    return !HIDDEN_CASHIN_STATUSES.includes(cashinOffer.get('status'));
}

regSub('ticketus/cashin', db => db.getIn(['ticketus', 'cashin'], Map()));

regSub(
    'ticketus/cashin-offer',
    () => subscribe(['ticketus/cashin']),
    (cashinDb, [_, ticketId]) => cashinDb.getIn(['tickets', ticketId])
);

regSub(
    'ticketus/cashin/cashin-offer/ticket',
    ([_, ticketId]) => subscribe(['ticketus/cashin-offer', ticketId]),
    cashinOffer => (isActiveCashin(cashinOffer) ? cashinOffer : null)
);

regSub(
    'ticketus/cashin/cashin-offer/tickets',
    () => subscribe(['ticketus/cashin']),
    cashinDb =>
        cashinDb
            .get('tickets', Map())
            .filter(Boolean)
            .filter(isActiveCashin)
            .toList()
);

regSub(
    'ticketus/cashin-offer/sport-events',
    () => subscribe(['ticketus/cashin']),
    (cashinDb, [_, eventId]) =>
        cashinDb
            .getIn(['sportEvents', eventId], Set())
            .map(ticketId => cashinDb.getIn(['tickets', ticketId]))
            .filter(Boolean)
            .filter(isActiveCashin)
);

regSub(
    'ticketus/cashin-offer/is-running',
    ([_, ticketId]) => subscribe(['ticketus/cashin-offer', ticketId]),
    cashinOffer => cashinOffer && cashinOffer.get('status') === cashinOfferStatus.Running
);

regSub('ticketus/channels', db => db.getIn(['nikeone', 'liveChannels'], Map()));

regSub('ticketus/auto-cashin-error', db => db.getIn(['ticketus', 'cashin', 'autoCashinError']));

export const ticketCashinTicketId$ = pathSubscription(['ticketus', 'closing', 'ticketId']);
export const currentClosingTicketId$ = pathSubscription(['ticketus', 'closing', 'ticketId']);
